import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'
import { DataContext } from './DataContext'
import { usePaymentActions } from '../hook/payment/usePayment/usePaymentActions'
import { usePaymentState } from '../hook/payment/usePayment/usePaymentState'
import { usePaymentEffects } from '../hook/payment/usePayment/usePaymentEffects'

export const PaymentContext = createContext()

export const PaymentProvider = ({ children }) => {
  const {
    userInfo,
    addressInfo,
    cartData,
    ecommerceInfo,
    clientMetaData
  } = useContext(DataContext)

  const {
    paymentState,
    setPaymentState,
    paymentOrderData,
    purchaseOrderData,
    paymentSetters,
    userToken
  } = usePaymentState(
    userInfo,
    addressInfo,
    cartData,
    ecommerceInfo,
    clientMetaData
  )

  const { paymentActions } = usePaymentActions({
    userToken,
    paymentState,
    setPaymentState,
    paymentOrderData,
    purchaseOrderData,
    paymentSetters
  })

  usePaymentEffects({
    userToken,
    paymentActions,
    setPaymentState,
    paymentState
  })

  return (
    <PaymentContext.Provider
      value={{
        paymentState,
        userToken,
        ...paymentState,
        setPaymentState,
        ...paymentActions,
        ...paymentSetters,
        paymentOrderData,
        purchaseOrderData
      }}
    >
      {children}
    </PaymentContext.Provider>
  )
}

PaymentProvider.propTypes = {
  children: PropTypes.node.isRequired
}
